export default "__VITE_ASSET__hRuxO7Lp__"